import type { FC, HtmlHTMLAttributes } from 'react';

import styles from './EmailSignatureEditorPanelSection.module.scss';

interface EmailSignatureEditorPanelSectionProps extends HtmlHTMLAttributes<HTMLDivElement> {
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

const EmailSignatureEditorPanelSection = ({
  ref: forwardedRef,
  children,
  onMouseEnter,
  onMouseLeave,
}: EmailSignatureEditorPanelSectionProps & {
  ref?: React.Ref<HTMLDivElement>;
}) => {
  return (
    <div
      onMouseEnter={() => onMouseEnter && onMouseEnter()}
      onMouseLeave={() => onMouseLeave && onMouseLeave()}
      ref={forwardedRef}
      className={styles['em-sig-side-editor-panel-section']}
    >
      {children}
    </div>
  );
};

const EmailSignatureEditorEmptyPanelSection = ({
  ref: forwardedRef,
  children,
  onMouseEnter,
  onMouseLeave,
}: EmailSignatureEditorPanelSectionProps & {
  ref?: React.Ref<HTMLDivElement>;
}) => {
  return (
    <div
      onMouseEnter={() => onMouseEnter && onMouseEnter()}
      onMouseLeave={() => onMouseLeave && onMouseLeave()}
      ref={forwardedRef}
      className={styles['em-sig-side-editor-empty-panel-section']}
    >
      {children}
    </div>
  );
};

const EmailSignatureEditorPanelSectionHeading: FC<React.PropsWithChildren<{ heading: string }>> = ({
  heading,
  children,
}) => {
  return (
    <div className={styles['em-sig-side-editor-panel-section-heading']}>
      <span className={styles['heading']}>{heading}</span>
      {children}
    </div>
  );
};

type EmailSignatureEditorPanelSectionHeadingButtonProps = {
  buttonText: string;
  onClick: () => void;
  isEmphasised?: boolean;
};

const EmailSignatureEditorPanelSectionHeadingButton: FC<
  React.PropsWithChildren<EmailSignatureEditorPanelSectionHeadingButtonProps>
> = ({ onClick, buttonText, isEmphasised = false }) => {
  return (
    <button
      data-is-emphasised={isEmphasised.toString()}
      onClick={(event: React.MouseEvent<HTMLSpanElement>) => {
        event.stopPropagation();
        onClick && onClick();
      }}
      className={styles['em-sig-side-editor-panel-section-dynamic-link']}
    >
      {buttonText}
    </button>
  );
};

const EmailSignatureEditorPanelSectionContents: FC<React.PropsWithChildren<{ disabled?: boolean }>> = ({
  children,
  disabled = false,
}) => {
  return (
    <div
      data-is-disabled={disabled.toString()}
      className={styles['em-sig-side-editor-panel-section-contents']}
    >
      {children}
    </div>
  );
};

EmailSignatureEditorPanelSection.displayName = 'EmailSignatureEditorPanelSection';

EmailSignatureEditorEmptyPanelSection.displayName = 'EmailSignatureEditorEmptyPanelSection';

export default EmailSignatureEditorPanelSection;

export {
  EmailSignatureEditorPanelSectionHeading,
  EmailSignatureEditorPanelSectionHeadingButton,
  EmailSignatureEditorPanelSectionContents,
  EmailSignatureEditorEmptyPanelSection,
};
